//返回数据图片添加域名
function ImageAddDomain(str,domain) {     
    //1，匹配出图片img标签（即匹配出所有图片），过滤其他不需要的字符
    //2.从匹配出来的结果（img标签中）循环匹配出图片地址（即src属性）
    var imgReg = /<img.*?(?:>|\/>)/gi;//正则匹配图片（g表示匹配所有结果i表示区分大小写）
    var srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;  //正则匹配src属性
    var arr = str.match(imgReg);   
   if(arr!=null){
    for (var i = 0; i < arr.length; i++) {
        var src = arr[i].match(srcReg);
        //获取图片地址
        if (src[1]) {
          str = str.replace(src[1], domain + src[1]);
        }
      }
   }
   return str;
}


// 获取url地址栏参数
function getUrlKey(name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}

export{
    ImageAddDomain,
    getUrlKey,
}
